(function(){

  /* ======================================================
     GLOBAL AJAX ATC ENGINE (UPSSELL DRAWER SAFE)
  ====================================================== */

document.addEventListener('submit', async function(e){

  const form = e.target;

  if(!form.closest('.cart-drawer__upsell-product')) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  if(!form.classList.contains('cart-drawer__upsell-atc-form')) return;

  const btn=form.querySelector('button[type="submit"]');
  if(btn) btn.disabled=true;

  try{

    const dataForm=new FormData(form);

    await fetch('/cart/add.js',{
      method:'POST',
      headers:{
        'Accept':'application/json',
        'X-Requested-With':'XMLHttpRequest'
      },
      body:dataForm
    });

    if(window.CartAPI && typeof window.CartAPI.buildCart==="function"){

      await window.CartAPI.buildCart();
      document.body.classList.add('cart-drawer--opened');

    }else{

      const cart=await fetch('/cart.js').then(r=>r.json());

      document.dispatchEvent(new CustomEvent('cart:updated',{detail:cart}));
      document.dispatchEvent(new CustomEvent('cart:change',{detail:cart}));
      document.dispatchEvent(new CustomEvent('cart:refresh',{detail:cart}));

    }

  }catch(err){
    console.error('Upsell ATC error',err);
  }

  if(btn) btn.disabled=false;

},true);



  /* ======================================================
     NATIVE UPSELL CAROUSEL ENGINE
  ====================================================== */

  function initNativeUpsell(){

    const wrap=document.querySelector('.js-upsell-carousel');
    if(!wrap || wrap.dataset.ready==="true") return;

    wrap.dataset.ready="true";

    const cards = wrap.querySelectorAll('.cart-drawer__upsell-product');

    function updateActive(){

      const wrapRect = wrap.getBoundingClientRect();
      const wrapCenter = wrapRect.left + (wrapRect.width / 2);

      let closest=null;
      let closestDistance=Infinity;

      cards.forEach(card=>{

        const rect = card.getBoundingClientRect();
        const cardCenter = rect.left + (rect.width/2);
        const distance = Math.abs(wrapCenter-cardCenter);

        if(distance < closestDistance){
          closestDistance=distance;
          closest=card;
        }

      });

      cards.forEach(c=>c.classList.remove('is-active'));

      if(closest){
        closest.classList.add('is-active');
      }

    }

    /* ===== ARROWS ===== */
    const gap = 14;
    const step = cards.length ? (cards[0].offsetWidth + gap) : 314;

    function getActiveIndex(){
      const active = wrap.querySelector('.cart-drawer__upsell-product.is-active');
      return active ? Array.from(cards).indexOf(active) : 0;
    }

    const prev=document.querySelector('.upsell-arrow.prev');
    const next=document.querySelector('.upsell-arrow.next');

    if(prev){
      prev.addEventListener('click',e=>{
        e.preventDefault();
        const currentIndex = getActiveIndex();
        const prevIndex = Math.max(0, currentIndex - 1);
        wrap.scrollTo({left: prevIndex * step, behavior:'smooth'});
      });
    }

    if(next){
      next.addEventListener('click',e=>{
        e.preventDefault();
        const currentIndex = getActiveIndex();
        const nextIndex = Math.min(cards.length - 1, currentIndex + 1);
        wrap.scrollTo({left: nextIndex * step, behavior:'smooth'});
      });
    }

    /* ===== ACTIVE UPDATE ===== */

    wrap.addEventListener('scroll',()=>{
      requestAnimationFrame(updateActive);
    });

    setTimeout(()=>{
      updateActive();
      wrap.classList.add('is-ready');
    },120);

  }


  /* ======================================================
     OBSERVER (SHOPIFY SECTION RERENDER SAFE)
  ====================================================== */

  const observer=new MutationObserver(()=>{
    initNativeUpsell();
  });

  observer.observe(document.body,{
    childList:true,
    subtree:true
  });

  document.addEventListener('DOMContentLoaded',initNativeUpsell);
  setTimeout(initNativeUpsell,500);

})();
